import {StyledLoadingTableRow} from './styles'
import {LoadingTableRowProps} from './types'
import {TableDataBase} from '../tableData/TableDataBase'
import {Skeleton} from '@viptech/react-components'

export default function LoadingTableRow({columns, loadingDataHeight}: LoadingTableRowProps) {
  return (
    <StyledLoadingTableRow>
      {columns.map((_, index) => {
        return (
          <TableDataBase key={`skeleton_${index}`}>
            <Skeleton width={`90%`} height={loadingDataHeight ?? '1.25rem'} borderRadius='4px' />
          </TableDataBase>
        )
      })}
    </StyledLoadingTableRow>
  )
}
